// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccountSettingsTableController from "./account_settings_table_controller"
application.register("account-settings-table", AccountSettingsTableController)

import ActiveCampTableController from "./active_camp_table_controller"
application.register("active-camp-table", ActiveCampTableController)

import AdminDataTemplateFormValidationController from "./admin_data_template_form_validation_controller"
application.register("admin-data-template-form-validation", AdminDataTemplateFormValidationController)

import AdminDatatemplateDatapointsTableController from "./admin_datatemplate_datapoints_table_controller"
application.register("admin-datatemplate-datapoints-table", AdminDatatemplateDatapointsTableController)

import AdminHeightFieldController from "./admin_height_field_controller"
application.register("admin-height-field", AdminHeightFieldController)

import AdminMailTableController from "./admin_mail_table_controller"
application.register("admin-mail-table", AdminMailTableController)

import AdminRefundsTableController from "./admin_refunds_table_controller"
application.register("admin-refunds-table", AdminRefundsTableController)

import AdminTableController from "./admin_table_controller"
application.register("admin-table", AdminTableController)

import AdminTeamTableController from "./admin_team_table_controller"
application.register("admin-team-table", AdminTeamTableController)

import AdminUserTableController from "./admin_user_table_controller"
application.register("admin-user-table", AdminUserTableController)

import AdminVisitorsTableController from "./admin_visitors_table_controller"
application.register("admin-visitors-table", AdminVisitorsTableController)

import AnnualEventsReportController from "./annual_events_report_controller"
application.register("annual-events-report", AnnualEventsReportController)

import AttendeesTableController from "./attendees_table_controller"
application.register("attendees-table", AttendeesTableController)

import BasicPhoneCleaveController from "./basic_phone_cleave_controller"
application.register("basic-phone-cleave", BasicPhoneCleaveController)

import CamperListTableController from "./camper_list_table_controller"
application.register("camper-list-table", CamperListTableController)

import CategoryController from "./category_controller"
application.register("category", CategoryController)

import CheckboxSelectAllController from "./checkbox_select_all_controller"
application.register("checkbox-select-all", CheckboxSelectAllController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CommandIndexTableController from "./command_index_table_controller"
application.register("command-index-table", CommandIndexTableController)

import DiscountCodesController from "./discount_codes_controller"
application.register("discount-codes", DiscountCodesController)

import DynamicSelectController from "./dynamic_select_controller"
application.register("dynamic-select", DynamicSelectController)

import EventTableController from "./event_table_controller"
application.register("event-table", EventTableController)

import FinancialOverviewController from "./financial_overview_controller"
application.register("financial-overview", FinancialOverviewController)

import FormValidationController from "./form_validation_controller"
application.register("form-validation", FormValidationController)

import KeyMetricsReportController from "./key_metrics_report_controller"
application.register("key-metrics-report", KeyMetricsReportController)

import MainMenuController from "./main_menu_controller"
application.register("main-menu", MainMenuController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import MilestonesController from "./milestones_controller"
application.register("milestones", MilestonesController)

import PasswordMatchController from "./password_match_controller"
application.register("password-match", PasswordMatchController)

import PasswordStrengthController from "./password_strength_controller"
application.register("password-strength", PasswordStrengthController)

import PasswordViewToggleController from "./password_view_toggle_controller"
application.register("password-view-toggle", PasswordViewToggleController)

import PastEventTableController from "./past_event_table_controller"
application.register("past-event-table", PastEventTableController)

import PerPageSelectController from "./per_page_select_controller"
application.register("per-page-select", PerPageSelectController)

import PricePointsController from "./price_points_controller"
application.register("price-points", PricePointsController)

import RegistrationsTableController from "./registrations_table_controller"
application.register("registrations-table", RegistrationsTableController)

import SearchableEventsTable from "./searchable_events_table_controller"
application.register("searchable-events-table", SearchableEventsTable)

import SelectController from "./select_controller"
application.register("select", SelectController)

import SwitchCampController from "./switch_camp_controller"
application.register("switch-camp", SwitchCampController)

import TableController from "./table_controller"
application.register("table", TableController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import UserCreateFormValidationController from "./user_create_form_validation_controller"
application.register("user-create-form-validation", UserCreateFormValidationController)

import UserMenuController from "./user_menu_controller"
application.register("user-menu", UserMenuController)
